// src/api/inventoryLogApi.js
import apiClient from "./axios";

const inventoryLogApi = {
  getAll: async (page = 1, pageSize = 10, search = "") => {
    const response = await apiClient.get("/inventory-logs/", {
      params: {
        page,
        page_size: pageSize,
        search: search.trim() || undefined, // Only send if not empty
      },
    });
    return response.data; // { data: [...], pagination: { ... } }
  },

  getById: async (id) => {
    const response = await apiClient.get(`/inventory-logs/${id}/`);
    return response.data;
  },
};

export default inventoryLogApi;
